<template>
<!-- 客源大厅 -->
<section class="viewContainer">
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="全部" name="first"/>
    <el-tab-pane label="已付费通话" name="second"/>
  </el-tabs>
  
  <!-- 全部 -->
  <div v-show="activeName=='first'">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="客户需求：" style="display:flex;width:26%" class="select">
            <el-select v-model="khxqid1" placeholder="请选择" filterable style="width:90%;">
              <el-option v-for="(item,index) in khxqArr1" :key="index" :value="item.dDicValue" :label="item.dDicName"/>
            </el-select>
          </el-form-item>
          <el-form-item label="登记时间：" style="display:flex;width:26%">
            <el-date-picker type="daterange" :title="value1" v-model="value1"
            value-format="yyyy-MM-dd" @change="changetime1" style="width:90%;"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item label="小区名称：" style="display:flex;width:26%">
            <el-input v-model="xqName1" placeholder="请输入小区名称" style="width:90%;"/>
          </el-form-item>
        </el-form>
        <el-form class="findform">
          <el-form-item label="客户户型：" style="display:flex;width:26%" class="select">
            <el-select v-model="khhxid1" placeholder="请选择" style="width:90%;">
              <el-option v-for="(item,index) in khhxArr1" :key="index" :value="item.dDicValue" :label="item.dDicName"/>
            </el-select>
          </el-form-item>
          <el-form-item label="房屋面积：" style="display:flex;width:26%">
            <div style="width:90%;display:flex;justify-content:space-between;">
              <el-input v-model="fwmjone1" placeholder="0  ㎡"/>
              <label style="margin: 0 5px"> - </label>
              <el-input v-model="fwmjtwo1" placeholder="9999 ㎡"/>
            </div>
          </el-form-item>
          <el-form-item label="客源质量：" style="display:flex;width:26%" class="select">
            <el-select v-model="kyzlId" placeholder="请选择" style="width:90%;">
              <el-option v-for="(item,index) in kyzlArr" :key="index" :value="item.id" :label="item.name"/>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right: 15px;"><el-button type="danger" @click="onSubmit">查询</el-button></el-form-item>
          <!-- <el-form-item v-show="customList.length>=2"><el-button type="danger" @click="ffth('')">批量付费</el-button></el-form-item> -->
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <div class="main_container">
      <el-checkbox v-model="qtsjyff" @change="handlePaid" style="float: left;margin: 10px 0 10px 10px;">其它商家已付费</el-checkbox>
      <!-- <div style="color: #F56C6C;text-align: right;margin: 10px 10px 5px 0;">重要提示：请按客户需求筛选查询出符合您店铺的客户资源。</div> -->
      <div class="table_container">
        <el-table :data="customList" stripe border>
          <!--  @selection-change="handleSelectionChange" -->
          <!-- <el-table-column type="selection" align="center" v-show="activeName == 'first'"/> -->
          <el-table-column prop="num" label="序号" width="60" align="center">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="customername" label="客户姓名" align="center"/>
          <el-table-column prop="address" label="小区名称" align="center"/>
          <el-table-column prop="cluetypename" label="客户需求" align="center"/>
          <el-table-column prop="remark" label="需求描述" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.remark" v-if="scope.row.remark">{{ scope.row.remark }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="cyclename" label="购买周期（天）" width="120" align="center"/>
          <el-table-column prop="createtime" label="登记日期" align="center"/>
          <el-table-column prop="buycount" label="其它商家付费(次)" align="center" width="160"/>
          <el-table-column prop="price" label="资源售价（元）" align="center">
            <template slot-scope="scope"> ￥{{scope.row.price}} </template>
          </el-table-column>
          <el-table-column prop="statusname" label="状态" align="center" width="120">
            <template scope="scope">
              <span>{{ scope.row.statusname }}
              <span v-show="scope.row.status==10||scope.row.status==14||scope.row.status==15">{{scope.row.refundreson}}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="280">
            <!-- status  订单状态：0=未购买  3=冻结中 5=已购买 10=申请退款 14=退款中 15=已退款 16=退款审核不通过 20=已取消 -->
            <template scope="scope">
              <span class="handle" @click="ffth(scope.row)" v-show="scope.row.status!=5&&scope.row.status!=10&&scope.row.status!=16&&scope.row.status!=3"> <i class="el-icon-goods"/> 付费通话 </span>
              <span class="handle" @click="shenheedit(scope.row)" v-show="scope.row.canrefund==1"> <i class="el-icon-time"/> 申请退款 </span>
              <span class="handle" @click="chexiaoedit(scope.row)" v-show="scope.row.status==10"> <i class="el-icon-aim"/> 撤销退款 </span>
              <!-- @click="khphone(scope.row)" -->
              <span class="handle" @click="ffth(scope.row)" v-show="scope.row.status==5||scope.row.status==10||scope.row.status==16||scope.row.status==3"> <i class="el-icon-phone"/> 客户电话 </span>
              <span class="handle" @click="showBillWatch(scope.row)" v-show="scope.row.status==5||scope.row.status==10||scope.row.status==16"> <i class="el-icon-notebook-2"/> 通话记录 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange1"
        :current-page="pageIndex1" :page-size="10" :total="totalnum1" style="float:right;margin:10px 0;"/>
      </div>
    </div>
  </div>
  <!-- 已付费通话 -->
  <div v-show="activeName=='second'">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="客户需求：" style="display:flex;width:30%" class="select">
            <el-select v-model="khxqid2" placeholder="请选择" filterable style="width:90%;">
              <el-option v-for="(item,index) in khxqArr2" :key="index" :value="item.dDicValue" :label="item.dDicName"/>
            </el-select>
          </el-form-item>
          <el-form-item label="登记时间：" style="display:flex;width:30%">
            <el-date-picker type="daterange" :title="value2" v-model="value2"
            value-format="yyyy-MM-dd" @change="changetime2" style="width:90%;"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item label="小区名称：" style="display:flex;width:30%">
            <el-input v-model="xqName2" placeholder="请输入小区名称" style="width:90%;"/>
          </el-form-item>
        </el-form>
        <el-form class="findform">
          <el-form-item label="客户户型：" style="display:flex;width:30%" class="select">
            <el-select v-model="khhxid2" placeholder="请选择" style="width:90%;">
              <el-option v-for="(item,index) in khhxArr2" :key="index" :value="item.dDicValue" :label="item.dDicName"/>
            </el-select>
          </el-form-item>
          <el-form-item label="房屋面积：" style="display:flex;width:30%">
            <div style="width:90%;display:flex;justify-content:space-between;">
              <el-input v-model="fwmjone2" placeholder="0  ㎡"/>
              <label style="margin: 0 5px"> - </label>
              <el-input v-model="fwmjtwo2" placeholder="9999 ㎡"/>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <div class="main_container">
      <section class="model_section">
        <el-col :span="18"> <p class="model_top_title">已付费通话</p> </el-col>
      </section>
      <div class="table_container">
        <el-table :data="purchaseList" stripe border>
          <el-table-column prop="num" label="序号" width="60" align="center">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="customername" label="客户姓名" align="center"/>
          <el-table-column prop="address" label="小区名称" align="center"/>
          <el-table-column prop="cluetypename" label="客户需求" align="center"/>
          <el-table-column prop="remark" label="需求描述" align="center" width="260">
            <template scope="scope">
              <span class="spanList" :title="scope.row.remark" v-if="scope.row.remark">{{ scope.row.remark }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="cyclename" label="购买周期（天）" align="center" width="120"/>
          <el-table-column prop="createtime" label="登记日期" align="center" width="120"/>
          <el-table-column prop="price" label="资源售价（元）" align="center">
            <template slot-scope="scope"> ￥{{scope.row.price}} </template>
          </el-table-column>
          <el-table-column prop="buytime" label="购买时间" align="center"/>
          <el-table-column label="操作" fixed="right" align="center" width="360">
            <template scope="scope">
              <span class="handle" @click="ffth(scope.row)" v-show="scope.row.status!=5&&scope.row.status!=10&&scope.row.status!=16"> <i class="el-icon-goods"/> 付费通话 </span>
              <span class="handle" @click="shenheedit(scope.row)" v-show="scope.row.canrefund==1"> <i class="el-icon-time"/> 申请退款 </span>
              <span class="handle" @click="chexiaoedit(scope.row)" v-show="scope.row.status==10"> <i class="el-icon-aim"/> 撤销退款 </span>
              <span class="handle" @click="khphone(scope.row)" v-show="scope.row.status==5||scope.row.status==10||scope.row.status==16"> <i class="el-icon-phone"/> 客户电话 </span>
              <span class="handle" @click="showBillWatch(scope.row)" v-show="scope.row.status==5||scope.row.status==10||scope.row.status==16"> <i class="el-icon-notebook-2"/> 通话记录 </span>
              <span class="handle" @click="showdoalo(scope.row)" v-show="scope.row.status==5||scope.row.status==10||scope.row.status==16"> <i class="el-icon-s-order"/> 跟进记录 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2"
        :current-page="pageIndex2" :page-size="10" :total="totalnum2" style="float:right;margin:10px 0;"/>
      </div>
    </div>
  </div>

  <!-- 通话记录 右侧抽屉组件 -->
  <el-drawer title="通话记录" custom-class="registrationRecord" :visible.sync="isBillWatch" size="30%">
    <el-table :data="seeLlnrList" border style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column label="通话时间" property="starttime" align="center"/>
      <el-table-column label="通话录音" align="center">
        <template scope="scope">
          <!-- <mini-audio audio-source="http://downsc.chinaz.net/files/download/sound1/201206/1638.mp3"/> -->
          <!-- <audio :src="scope.row.recordurl" controls="controls" style="width: 90%;height: 35px;margin: 5px 0;"/> -->
          <audio :src="api2cs + '/api/virtualnumber/callaudio/'+scope.row.tag+'/'+scope.row.callid+'/'+scope.row.orderid"
          v-show="scope.row.isexpires==0&&scope.row.tag" controls="controls" style="width: 90%;height: 35px;margin: 5px 0;"/>
          <span v-show="scope.row.isexpires==1">录音已过期</span>
          <span v-show="scope.row.tag==''||scope.row.tag==0">录音未生成</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 通话记录-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handlethjl"
      :current-page="pageIndex" :page-size="10" :total="pagetotal" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  <!--申请退款-->
  <el-drawer title="申请退款" custom-class="registrationRecord" :visible.sync="shenFormVisble" size="30%">
    <div>
      <b>退款原因：</b>
      <div style="padding-top: 15px;">
        <el-radio-group v-model="radiothree">
          <!-- <el-radio :label="1">无效号码</el-radio> -->
          <el-radio :label="2">没有需求</el-radio>
          <!-- <el-radio :label="3">无人接听</el-radio> -->
          <p style="margin: 15px 0;"><el-radio :label="4">其它原因</el-radio></p>
        </el-radio-group>
      </div>
      <el-form v-show="radiothree==4">
        <el-form-item style="width: 80%;">
          <el-input type="textarea" v-model="tkly" placeholder="请描述申请退款理由，最多不超过100字。"
          maxlength="100" style="width:90%;"/>
        </el-form-item>
        <p>申诉资料图片 {{this.imgarr.length}}/9</p>
        <div style="display:flex;flex-wrap:wrap">
          <div v-for="(item,index) in imgarr" :key="index" style="display:inline-block; position: relative;line-height: normal;">
            <img @click="deleteimg(index,item)" src="../../assets/img/aicon36.png"
            style="position:absolute;right:6px;top:-8px;cursor: pointer;z-index: 9;width: 20px;"/>
            <el-image :src="item" @click="handleClickItem" :preview-src-list="imgarr"
            style="width:80px;height:80px;margin-right: 15px;margin-bottom: 5px;"/>
          </div>
          <el-upload v-show="isdisabled" class="avatar-uploader" style action :show-file-list="false" :before-upload="beforeAvatarUpload">
            <img style="width:80px;height:80px;" v-if="CoverImg" :src="CoverImg" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </div>
      </el-form>
    </div>
    <div style="line-height: 26px;margin-bottom: 10px;color: #F56C6C;">
      <b style="float: left;">退款提示：</b>
      <br>
      <div>平台会根据您与该客户过往通话记录作为退款审核依据，请认真自查后再申请退款。</div>
    </div>
    <div style="text-align:center">
      <el-button @click="shenFormVisble = false">取消</el-button>
      <el-button type="danger" @click="billSubmit(1)">确定</el-button>
    </div>
  </el-drawer>
  <!-- 撤销退款 -->
  <el-dialog title='撤销退款' :visible.sync="visiblechexiao" width="20%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 30px 0; font-size: 16px;">确定要求撤销申请退款吗？撤销退款后可能会无法再次申请退款。</p>
    </div>
    <div style="text-align:center">
      <el-button @click="visiblechexiao = false">取消</el-button>
      <el-button type="danger" @click="billSubmit(2)">确定</el-button>
    </div>
  </el-dialog>
  <!-- 客户电话 -->
  <el-dialog title='客户电话' :visible.sync="visiblePhone" width="30%" center>
    <div style="text-align:center;"><b style="margin: 10px 0 30px 0; font-size: 18px;">{{numPhone}}</b></div>
    <ul style="margin: 10px 0 30px 0; font-size: 16px;line-height: 26px;">
      <b>通话规则：</b>
      <li>1.请用<span style="color: #409EFF;">“{{userPhone}}”</span>进行拨打；</li>
      <li>2.拨打前将冻结此客户信息费，无效或未拨通均不扣费，如有扣费异议请进入“已购客源”列表申诉，平台在24小时内处理。</li>
      <li>3.您拨打的是客户隐私号，请在3分钟内拨打；</li>
      <li>4.通话计费标准为0.1元/1分钟，每日23点出结算账单；</li>
    </ul>
    <div style="text-align:center">
      <el-button type="danger" @click="visiblePhone = false">确定</el-button>
    </div>
  </el-dialog>
  <!-- 微信扫码支付 -->
  <el-dialog title="微信扫码支付" :visible.sync="wxsmzfVisible" width="20%" center @close="closeWxsmzf">
    <div style="width: 90%; margin: 0 auto; text-align: center;">
      <b style="font-size: 26px;">{{wxsmzfJine}} 元</b>
      <div style="color: #ccc;">（含6‰手续费）</div>
      <img :src="wxSmzfImg" style="width: 200px;"/>
    </div>
  </el-dialog>
  
  <el-dialog title="跟进记录" :visible.sync="dialogVisibledelete" :before-close="handleClosezhun" center>
    <span>
      <el-table :data="followList" stripe border style>
        <el-table-column prop="name" label="跟进人" width="200px" align="center"/>
        <el-table-column prop="time" label="跟进时间" width="200px" align="center"/>
        <el-table-column prop="content" align="center" width label="跟进内容"/>
      </el-table>
      <div style="overflow:hidden">
        <el-pagination layout="prev, pager, next" @current-change="handlegjjl"  
        :current-page="pageindexgjjl" :page-size="5" :total="totalgjjl" style="float:right;margin-top:10px"/>
      </div>
      <div style="height:1px;background:#eee;margin-top:10px"></div>
      <div style="margin-top:10px;font-weight: bold;">添加跟进记录</div>
      <el-input type="textarea" v-model="remark" maxlength="200" placeholder="请输入跟进记录（200字以内）"
        :autosize="{ minRows: 2, maxRows: 6}" show-word-limit style="margin-top:10px;"/>
    </span>
    <span slot="footer" style="text-align:center" class="dialog-footer">
      <div style="text-align:center">
        <el-button type="danger" @click="followUp()">保 存</el-button>
      </div>
    </span>
  </el-dialog>
  <!-- 图片预览 -->
  <el-dialog :visible.sync="isShowImageDialog" @closed="clearImg" title='图片查看'>
    <!-- <el-carousel indicator-position="outside" min-height="400" :arrow = "spanshow">
      <el-carousel-item v-for="(src,index) in imgs" :key="index" >
        <img  :src="src" style="max-width: 100%;height: 565px;display: block; margin: 0 auto;" />
      </el-carousel-item>
    </el-carousel> -->
    <el-carousel :autoplay = "false">
      <el-carousel-item v-for="(item,index) in multiImagePreview" :key="index">
        <img style="width:100%;height:100%" :src="multiImagePreview[index]" />
      </el-carousel-item>
    </el-carousel>
  </el-dialog>
  
  <!-- 确认提示 -->
  <el-dialog title='确认提示' :visible.sync="fufeidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 20px 0; font-size: 16px;">您确定要进行付费通话吗？</p>
      <b style="font-size: 18px;">-{{zysj}} 元</b>
    </div>
    <div style="text-align:center;margin-top: 20px;">
      <el-button @click="fufeidialog = false">取消</el-button>
      <el-button type="danger" @click="qdfufeu()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 充值提示 -->
  <el-dialog title='充值提示' :visible.sync="priorityRecharge" width="25%" center>
    <p style="text-align:center;margin-bottom: 30px;">当前账户已欠费{{owemoney}}元，请先对账户充值再进行呼叫。</p>
    <div style="text-align:center">
      <el-button @click="priorityRecharge = false" style="width: 100px;">取消</el-button>
      <el-button type="danger" @click="quchongzhi()" style="width: 100px;">去充值</el-button>
    </div>
  </el-dialog>

  <!-- 充值提示 -->
  <el-dialog title='充值提示' :visible.sync="chongzhidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 30px 0; font-size: 16px;">{{ chognzhitishi }}</p>
    </div>
    <div style="text-align:center;">
      <el-button @click="chongzhidialog = false">取消</el-button>
      <el-button type="danger" @click="quchongzhi()">去充值</el-button>
    </div>
  </el-dialog>

  <!-- 请选择店铺 -->
  <el-dialog title="请选择店铺" :visible.sync="dialogSksz" width="25%" center>
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="handleChangeQymc">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss';
import { userIdentity, datadictionaryGetlist, payment, getOssFile } from "../../api/newOss";
import { oldsellgetlist, newsellgetlist, sellispaid, orderchangestatus, bindphone, callrecordlist, getfollowuplist, addfollowup } from "../../api/shopWindow";
export default {
  name: "resourceLibrary",
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      
      dialogSksz: false, // 初始化弹框
      options1: [],
      bbid:'',  // 店铺id
      shopname: '', // 店铺名称
      bbtype: '', // 店铺类型

      activeName: 'first', // tab切换标识
      khxqArr1: [{
        dDicValue: 0,
        dDicName: "全部",
      }], // 客户需求集合
      khxqArr2: [], // 客户需求集合
      khhxArr1: [], // 客户户型集合
      khhxArr2: [], // 客户户型集合
      
      khxqid1: 0,
      value1:'',
      date1: "",
      date2: "",
      xqName1: "",
      khhxid1: '',
      fwmjone1: '', // 房屋面积-前
      fwmjtwo1: '', // 房屋面积-后
      kyzlId: 0,
      kyzlArr: [
        {
          id: 0,
          name: '全部'
        },{
          id: 1,
          name: '高质客源'
        },{
          id: 2,
          name: '优质客源'
        },{
          id: 3,
          name: '潜在客源'
        },
      ],

      qtsjyff: false, // 其它商家已付费
      customList: [], // 客源大厅-列表
      pageIndex1: 1, // 页码
      totalnum1: 0, // 总条数
      batchliveListArr:[], // 复选框选中项
      
      khxqid2: 0,
      value2:'',
      date3: "",
      date4: "",
      xqName2: "",
      khhxid2: '',
      fwmjone2: '', // 房屋面积-前
      fwmjtwo2: '', // 房屋面积-后
      purchaseList: [], // 已付费通话-列表
      pageIndex2: 1, // 页码
      totalnum2: 0, // 总条数

      cucctrid: "", // 选中行id
      orderid: '', // 订单id

      isShowImageDialog:false,
      multiImagePreview:[1,2,3,4],
      
      isBillWatch: false, // 抽屉-通话记录
      seeLlnrList: [], // 抽屉列表
      pageIndex: 1, // 页码
      pagetotal: 0, // 总条数

      shenFormVisble: false, // 申请退款
      radiothree: 1, // 退款原因
      tkly: '', // 退款理由
      imgarr: [], // 全连接
      FileID: [], // 切割之后的
      isdisabled: true,
      CoverImg:"",
      visiblechexiao: false, // 撤销退款
      
      timer: null, // 轮询
      lxTime: 0, // 初始开始请求时间
      wxsmzfVisible: false, // 微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码
      
      visiblePhone: false, // 客户电话
      numPhone: '', // 用户手机号
      userPhone: '', // 当前登录人手机号

      dialogVisibledelete: false, // 跟进记录
      followList: [],
      pageindexgjjl: 1,
      totalgjjl: 0,
      remark: "",
      fufeidialog: false, // 确认提示
      zysj: 0, // 资源售价
      chongzhidialog: false, // 充值提示
      chognzhitishi: '', // 提示文案
      
      priorityRecharge: false,
      owemoney: '', // 欠费金额
      api2cs: localStorage.api2cs,
    };
  },
  methods: {
    // 切换tab
    handleClick(tab){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      if(tab.name=='first'){
        // this.pageIndex1 = 1;
        // this.init();
      }
      if(tab.name=='second'){
        this.khxqid2 = 0;
        this.xqName2 = '';
        this.khhxid2 = '';
        this.fwmjone2 = '';
        this.fwmjtwo2 = '';
        this.pageIndex2 = 1;
        this.purchased();
      }
    },
    // 重置
    fnReset() {
      this.khxqid1 = 0;
      this.khxqid2 = '';
      this.value1 = '';
      this.date1 = '';
      this.date2 = '';
      this.value2 = '';
      this.date3 = '';
      this.date4 = '';
      this.xqName1 = '';
      this.xqName2 = '';
      this.khhxid1 = '';
      this.khhxid2 = '';
      this.fwmjone1 = '';
      this.fwmjtwo1 = '';
      this.fwmjone2 = '';
      this.fwmjtwo2 = '';
    },
    // 查询
    onSubmit() {
      if(this.activeName=='first'){
        // if(!this.khxqid1) {
        //   this.showAlert('请先选择客户需求，再查询');
        //   return false;
        // } else{
          this.pageIndex1 = 1;
          this.init();
        // }
      }
      if(this.activeName=='second'){
        this.pageIndex2 = 1;
        this.purchased();
      }
    },
    // 其它商家已付费
    handlePaid(val){
      this.qtsjyff = val;
      this.pageIndex1 = 1;
      this.init();
    },
    // 获取列表
    init() {
      let obj = {
        // shopid: this.bbid, // 店铺id
        iscalled: 0, // 列表类型：0=全部 1=已付费通话
        cluetype: Number(this.khxqid1), // 客户需求ID
        cycleid: 0, // 需求周期 0=全部
        buybdate: this.date1,
        buyedate: this.date2,
        keyword: this.xqName1, // 小区名称
        housetypeid: Number(this.khhxid1), // 客户户型ID
        bfloorspace: this.fwmjone1?this.fwmjone1:0, // 房屋面积-起始值
        efloorspace: this.fwmjtwo1?this.fwmjtwo1:0, // 房屋面积-截止值
        otherispayed: this.qtsjyff==true?1:0, // 其它商家已付费0=全部 1=只展示其它商家已购买的客户
        level: this.kyzlId, // 客源质量
        pageindex: this.pageIndex1, // 当前页
        pagesize: 10, // 分页数
      };
      newsellgetlist(obj,1, this.bbid).then(data => {
        if(data.resultCode == 1){
          this.customList = data.resultObj.list;
          this.totalnum1 = data.resultObj.totalcount;
        }else{
          this.customList = [];
          this.totalnum1 = 0;
        }
      })
    },
    // 分页
    handleCurrentChange1(val) {
      this.pageIndex1 = val;
      this.init();
    },
    // 获取已付费通话列表
    purchased() {
      let obj = {
        // shopid: this.bbid, // 店铺id
        // iscalled: 1, // 列表类型：0=全部 1=已付费通话
        // cluetype: Number(this.khxqid2), // 客户需求ID
        // cycleid: 0, // 需求周期 0=全部
        // buybdate: this.date3,
        // buyedate: this.date4,
        // keyword: this.xqName2, // 小区名称
        // housetypeid: Number(this.khhxid2), // 客户户型ID
        // bfloorspace: this.fwmjone2?this.fwmjone2:0, // 房屋面积-起始值
        // efloorspace: this.fwmjtwo2?this.fwmjtwo2:0, // 房屋面积-截止值
        // pageindex: this.pageIndex2, // 当前页
        // pagesize: 10, // 分页数
        shopid: this.bbid, // 店铺id
        tabid: 1, // 列表类型：0=全部 1=已付费通话
        cluetype: this.khxqid2, // 客户需求ID
        bdate: this.date3,
        edate: this.date4,
        address: this.xqName2, // 小区名称
        housetypeid: Number(this.khhxid2), // 客户户型ID
        bfloorspace: this.fwmjone2, // 房屋面积-起始值
        efloorspace: this.fwmjtwo2, // 房屋面积-截止值
        pageindex: this.pageIndex2, // 当前页
        pagesize: 10, // 分页数
      };
      oldsellgetlist(obj,1, this.bbid).then(data => {
        if(data.resultCode == 1){
          this.purchaseList = data.resultObj.list;
          this.totalnum2 = data.resultObj.totalcount;
        }else{
          this.purchaseList = [];
          this.totalnum2 = 0;
        }
      })
    },
    // 分页
    handleCurrentChange2(val) {
      this.pageIndex2 = val;
      this.purchased();
    },
    // 关闭跟进记录弹框+刷新列表
    handleClosezhun() {
      this.dialogVisibledelete = false;
      this.purchased();
    },
    // 跟进记录
    showdoalo(row) {
      this.orderid = row.orderid;
      this.pageindexgjjl = 1;
      this.getgjjl();
      this.dialogVisibledelete = true;
    },
    // 获取跟进记录
    getgjjl() {
      let obj = {
        orderid: this.orderid, // 订单ID
        pageindex: this.pageindexgjjl,
        pagesize: 5
      };
      getfollowuplist(obj).then(data => {
        if (data.resultCode == 1) {
          this.followList = data.resultObj.list; // 通话记录集合
          this.totalgjjl = data.resultObj.totalcount;
        } else{
          this.followList = data.resultObj.list;
          this.totalgjjl = data.resultObj.totalcount;
        }
      });
    },
    // 分页
    handlegjjl(val) {
      this.pageindexgjjl = val;
      this.getgjjl();
    },
    // 保存
    followUp() {
      if (this.remark == "") {
        this.showAlert('请添加跟进记录');
        return false;
      }
      let obj = {
        orderid: this.orderid, // 订单ID
        content: this.remark, // 跟进内容
        operatorid: localStorage.Id, // 操作人ID
      };
      addfollowup(obj).then(data => {
        if (data.resultCode == 1) {
          // this.dialogVisibledelete = false
          this.remark = "";
          this.showAlert('保存成功', 'success');
          this.getgjjl();
        }else{
          this.showAlert(data.resultMsg);
        }
      });
    },
    // 时间1
    changetime1() {
      if(this.value1+""=="null"){
        this.value1 = ["",""]
      }
      this.date1 = this.value1[0];
      this.date2 = this.value1[1];
    },
    // 时间2
    changetime2() {
      if(this.value2+""=="null"){
        this.value2 = ["",""]
      }
      this.date3 = this.value2[0];
      this.date4 = this.value2[1];
    },
    // 申请退款
    shenheedit(row) {
      this.shenFormVisble = true;
      this.orderid = row.orderid;
    },
    // 撤销退款
    chexiaoedit(row){
      this.visiblechexiao = true;
      this.orderid = row.orderid;
    },
    // 确定退款 & 撤销退款
    billSubmit(type) {
      if (this.radiothree == 4) {
        if(this.tkly==''){
          this.showAlert('请输入退款理由');
          return false;
        }
      }
      let obj = {
        shopid: this.bbid, // 店铺id
        orderid: this.orderid, // 订单ID
        status: type==1?10:5, // 状态：10=申请退款 14=同意退款 16=不同意退款
        operatorid: localStorage.Id, // 操作人id
        resonid: this.radiothree, // 申请退款原因ID （申请退款时必传）
        reson: this.tkly, // 退款原因 resonid=4时必传
        refundimgs: this.imgarr.map(item => item.replace(localStorage.BaseOssUrl, '')).join(','), // 退款图片 多个图片用英文逗号隔开
      };
      orderchangestatus(obj).then(data => {
        type==1?this.shenFormVisble = false:this.visiblechexiao = false;
        this.showAlert('操作成功', 'success');
        this.init();
        this.purchased();
      })
    },
    // 客户电话
    khphone(row){
      this.orderid = row.orderid;
      this.getVirtualNum();
    },
    // 获取虚拟手机号及登录人手机号
    getVirtualNum(){
      let obj = {
        operatorid: localStorage.Id, // 当前操作人ID
        orderid: this.orderid, // 订单ID
        shopid: this.bbid, // 店铺ID
      };
      bindphone(obj).then(data => {
        if(data.resultCode == 1){
          this.visiblePhone = true;
          this.numPhone = data.resultObj.virtualnumber; // 赋值 虚拟手机号
          this.userPhone = data.resultObj.callingnumber; // 登录人手机号
        }else if(data.resultCode == 4){
          this.priorityRecharge = true;
          this.owemoney = data.resultObj; // 欠费金额
        }else{
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 通话记录
    showBillWatch(row) {
      this.isBillWatch = true;
      this.orderid = row.orderid;
      this.getpiaoju();
    },
    // 通话记录
    getpiaoju() {
      let obj = {
        orderid: this.orderid, // 订单ID
        businessid: this.bbid, // 店铺ID
        pageindex: this.pageIndex,
        pagesize: 10,
      };
      callrecordlist(obj).then(data => {
        if(data.resultCode == 1){
          this.seeLlnrList = data.resultObj.list;
          this.pagetotal = data.resultObj.totalcount;
        }else{
          this.seeLlnrList = [];
          this.pagetotal = 0;
        }
      })
    },
    // 通话记录-分页
    handlethjl(val){
      this.pageIndex = val;
      this.getpiaoju();
    },
    // 确定付费
    qdfufeu(){
      // this.fufeidialog=false;
      
      // 支持批量购买，多个客户需求用竖线(|)隔开
      let obj = {
        attach: 'customerclueorder,' + this.cucctrid,
        price: 0, // 支付金额 单位：元 （店铺分享赚钱必传）
        operatorid: localStorage.Id, // 操作人ID
        isconfirm: 1, // 是否确认支付 0=否 1=是 （非确认支付只返回支付金额 单位：元）
      };
      payment(obj,3, this.bbid).then(data => {
        if (data.resultCode == 1) {
          // this.showAlert('操作成功', 'success');
          // this.init();
          // this.purchased();
          // this.orderid = data.resultObj[0]; // 订单ID
          this.orderid = data.resultObj; // 订单ID
          if(this.orderid){
            this.getVirtualNum();
          }
        }else if(data.resultCode == 4){
          this.chongzhidialog=true; // 充值提示
          this.chognzhitishi=data.resultObj; // 提示文案
        }else{
          this.showAlert(data.resultMsg);
        }
      });
    },
    // 去充值
    quchongzhi(){
      // this.$router.push({path: "/vmacount"}); // 跳转店铺钱包
      this.$router.push({
        path: "/vmacount",
        query: { shopid: this.bbid }
      });
    },
    // 复选框
    handleSelectionChange(val) {
      this.batchliveListArr = [];
      val.forEach(element => {
        // this.batchliveListArr.push(element.cucctrid);
        this.batchliveListArr.push({"cucctrid":element.cucctrid, "price":element.price});
      });
    },
    // 付费通话 & 批量付费
    ffth(row){
      if(!row){
        if(this.batchliveListArr.length == 0){
          this.showAlert('请至少选择一条数据');
          return false
        }
      }
      let sum = 0;
      this.batchliveListArr.forEach(item => {
        //遍历price字段，并累加
        sum += Number(item.price);
          this.zysj = sum;
      });
      this.zysj=row.price?row.price:sum; // 资源售价
      this.cucctrid=row.cucctrid?row.cucctrid:this.batchliveListArr.map(item=>item.cucctrid).join('|');
      
      // this.fufeidialog=true;
      this.qdfufeu(); // 确定付费

      // this.cucctrid=row.cucctrid?row.cucctrid:this.batchliveListArr.join('|');
      // var obj = {
      //   attach: 'customerclueorder,' + this.bbid +','+ this.cucctrid +','+ localStorage.Id
      // };
      // postPlaceOrderNative(obj).then(data => {
      //   if (data.ResultCode == 1) {
      //     this.wxsmzfVisible = true;
      //     this.wxsmzfJine = data.resultObj.price; // 金额（单位0）
      //     this.wxSmzfImg = data.resultObj.qrCode; // resultCode=1时返回base64格式二维码图片
          
      //     this.lxTime = new Date().getTime() // 获取触发轮询时的时间
      //     this.inquireData() // 调用轮询接口,开始进行轮询
          
      //   } else if(data.ResultCode == 4) {
      //     this.showAlert('支付成功', 'success');
      //     this.init();
      //     this.purchased();
      //   }
      // });
    },
    // 二维码弹框-关闭
    closeWxsmzf() {
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.timer)
    },
    // 轮询请求
    inquireData () {
      const reload = () => {
        clearTimeout(this.timer) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.lxTime > 5 * 60 * 1000) {
          clearTimeout(this.timer)
          return
        }
        // 3s一次, 轮询中
        this.timer = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      let cucctrid = this.cucctrid.length>0?this.cucctrid.split('|')[0]:this.cucctrid;
      sellispaid('',this.bbid,cucctrid).then(res => {
        if (res && res.resultCode === 1) {
          // true=已充值、false = 未充值
          if(res.resultObj) {
            this.wxsmzfVisible = false; // 二维码弹窗消失
            this.showAlert('支付成功', 'success');
            this.init();
            this.purchased();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 客户需求
    getkhxq(){
      let obj = {
        code: 'custom_clue_type',
      }
      datadictionaryGetlist(obj).then(data=>{
        if(data.resultCode == 1){
          this.khxqArr1 = data.resultObj;
          this.khxqArr1.unshift({
            dDicValue: 0,
            dDicName: "全部",
          });
        }
      })
      datadictionaryGetlist(obj).then(data=>{
        if(data.resultCode == 1){
          this.khxqArr2 = data.resultObj;
          this.khxqArr2.unshift({
            dDicValue: 0,
            dDicName: "全部",
          });
        }
      })
    },
    // 客户户型
    getkhhx(){
      let obj = {
        code: 'house_type',
      }
      datadictionaryGetlist(obj).then(data=>{
        if(data.resultCode == 1){
          this.khhxArr1 = data.resultObj;
          this.khhxArr2 = data.resultObj;
        }
      })
    },
    // 初始化查询店铺
    handleSksz(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              this.dialogSksz = true;
              this.options1 = data.resultObj;
            } else {
              this.dialogSksz = false;
              this.bbid = data.resultObj[0].id; // 店铺id
              this.shopname = data.resultObj[0].name;
              this.bbtype = data.resultObj[0].shopType; // 店铺类型
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺');
            return false;
          }
        }
      })
    },
    // 获取店铺名称 & 店铺类型
    handleChangeQymc(val) {
      this.options1.filter(item => {
        if(item.id == val){
          this.shopname = item.name; // 店铺名称
          this.bbtype = item.shopType; // 店铺类型
        }
      })
    },
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false;
      }
      this.init();
      this.getkhxq(); // 获取客户需求
      this.getkhhx(); // 获取客户户型
      this.dialogSksz = false;
    },
    seebigimg(arr){
      this.isShowImageDialog = true;
      this.multiImagePreview = arr;
    },
    clearImg(){
      this.isShowImageDialog = false;
    },
    // 删除图片
    deleteimg(index) {
      this.imgarr.splice(index, 1);
      // this.FileID.splice(index, 1);
      if (this.imgarr.length >= 9) {
        this.isdisabled = false;
      }else{

        this.isdisabled = true;
      }
    },
    // 商品图片
    beforeAvatarUpload(file) {
      const isSize = new Promise(function(resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          resolve()
        };
      })
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 5MB');
        return;
      }
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // oss 直传图片
          var obj = {type: 11};
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
              uploadOSS(file,0).then(data => {
                var newOssPic = data;
                that.imgarr.push(newOssPic);
                that.FileID = newOssPic.replace(localStorage.BaseOssUrl,'')
              })
            }
          })

        };
        if (that.imgarr.length >= 8) {
          that.isdisabled = false;
        }
      });
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  mounted() {
    this.handleSksz(); // 查店铺
  },
};
</script>
<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #ddd;
  text-align: center;
  cursor: pointer;
  margin-bottom: 10px;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// resourceLibrary.vue?00778f8e